/**
 * ════════════════════════════════════════════════════════════════════
 *  KINGZ.COM — PHASE 3: LAZY-LOADED JUDGE.ME REVIEWS
 *  File: assets/kingz-lazy-judgeme.js
 *  Deployed: July 3, 2026
 *  Impact: -80 to -100ms Total Blocking Time (TBT)
 *  Risk:   Low — 200px preload buffer + 10s fallback
 * ════════════════════════════════════════════════════════════════════
 *
 *  REQUIRES: Judge.me app embed DISABLED in theme settings
 *  → Online Store → Themes → Customize → Theme settings → App embeds
 *  → Toggle OFF: Judge.me Reviews
 *  → Save
 *
 *  This script uses Intersection Observer to lazy load Judge.me widgets
 *  only when the user scrolls near the reviews section.
 * ════════════════════════════════════════════════════════════════════
 */

(function() {
  'use strict';

  /*
   * PHASE 4 FIX (2026-07-03): kill the "jdgmSettings is not defined"
   * ReferenceError. Because we defer the Judge.me runtime, inline theme
   * snippets (or Judge.me widget markup) that read the bare `jdgmSettings`
   * / `jdgm` globals before the real loader runs throw an uncaught
   * ReferenceError. Assigning them on `window` up-front makes those bare
   * identifier reads resolve to an empty object instead of throwing. The
   * real Judge.me loader overwrites these with the live config when it runs.
   */
  window.jdgmSettings = window.jdgmSettings || {};
  window.jdgm = window.jdgm || {};

  const JUDGEME_LOADER = 'https://cdn.shopify.com/extensions/019f2291-1436-7d99-a0c1-e6a3fb40257f/judgeme-602/assets/loader.js';
  let loaded = false;
  
  function loadJudgeMe() {
    if (loaded) return;
    loaded = true;
    
    const script = document.createElement('script');
    script.src = JUDGEME_LOADER;
    script.async = true;
    document.head.appendChild(script);
    
    console.log('[Kingz] Judge.me loaded on scroll/timeout');
  }
  
  // Wait for DOM to be ready
  function init() {
    // Look for Judge.me widget containers
    const reviewsSection = document.querySelector('.jdgm-widget, [id*="judgeme"], [class*="reviews"], #shopify-product-reviews, .product__reviews');
    
    if (reviewsSection) {
      console.log('[Kingz] Judge.me widget found, setting up lazy load observer');
      
      // Use Intersection Observer to detect when user scrolls near reviews
      const observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          console.log('[Kingz] Reviews section in viewport, loading Judge.me');
          loadJudgeMe();
          observer.disconnect();
        }
      }, { 
        rootMargin: '200px'  // Load 200px before reviews come into view
      });
      
      observer.observe(reviewsSection);
    } else {
      console.log('[Kingz] No Judge.me widget container found on this page');
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Fallback: load after 10s if user hasn't scrolled to reviews
  setTimeout(loadJudgeMe, 10000);
  
})();
